/**
 * Prismic Preview Configuration
 *
 * Configures preview functionality for the Prismic integration.
 * Maps Prismic document types to their corresponding React templates.
 */

import { linkResolver } from "./linkResolver";

// Import templates for preview resolution
import HomepageTemplate from "../templates/homepage";
import AboutTemplate from "../templates/about";

/**
 * Repository configurations for Prismic previews
 *
 * Each repository needs:
 * - repositoryName: The Prismic repository name
 * - linkResolver: Function to resolve document URLs
 * - componentResolver: Maps document types to React components
 */
export const repositoryConfigs = [
  {
    repositoryName: process.env.GATSBY_PRISMIC_REPO_NAME,
    linkResolver,
    componentResolver: {
      homepage: HomepageTemplate,
      about_page: AboutTemplate,
    },
  },
];
